import { TextInput } from 'components/ui'
import { get } from 'lodash'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import useLocaleText from 'components/useLocaleText'
import { Subtask } from 'components/TasksV2/TaskCreation/FormStepContext'

interface Props {
  titleName: string
  field: Subtask
}
export const LinkTitle: React.FC<Props> = ({ titleName, field }) => {
  const { control, errors } = useFormContext()
  const validationMessage = useLocaleText('t_link_st_error')
  const t_link_title = useLocaleText('t_link_title')

  return (
    <Controller
      as={TextInput}
      name={titleName}
      id={titleName}
      control={control}
      placeholder={t_link_title}
      rules={{
        required: validationMessage,
        validate: (value) => {
          return value.trim() !== '' || validationMessage
        },
      }}
      key={titleName}
      elementHeight="40px"
      isInvalid={!!get(errors, titleName)}
      errorMessage={validationMessage}
      defaultValue={field.title}
    />
  )
}
